import { render, staticRenderFns } from "./MStateBox.vue?vue&type=template&id=bec373d4&scoped=true"
import script from "./MStateBox.vue?vue&type=script&setup=true&lang=js"
export * from "./MStateBox.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MStateBox.vue?vue&type=style&index=0&id=bec373d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec373d4",
  null
  
)

export default component.exports